import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-50 mb-6">
        <i className="ri-error-warning-line text-4xl text-primary-500"></i>
      </div>
      <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
        404
      </h1>
      <p className="text-lg text-foreground-600 mb-8">
        Seite nicht gefunden
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors"
      >
        <i className="ri-arrow-left-line"></i>
        Zurück zur Startseite
      </Link>
    </div>
  );
}